import React from 'react';

const sections = ['hero', 'about', 'projects', 'contact'];

const DotNav: React.FC = () => {
  return (
    <div className="dot-nav">
      {sections.map((section) => (
        // eslint-disable-next-line
        <a key={section} href={`#${section}`} className="dot" data-section={section}></a>
      ))}
    </div>
  );
};

export default DotNav;